export let panelRouterEvaluation = {
  bindings: {
    data: '<',
    action: '<'
  },
  template: `
    <div class="ui-grid-cell-contents">
      <a>
        <i class="icon {{ vm.map }} i-20" style="padding-right: 5px; opacity: 1"></i>
      </a>
      <a class="line-down" ng-click="vm.router(vm.route, vm.header)">
        {{ vm.action }}
      </a>
    </div>`,
  controllerAs: 'vm',
  controller: ['Validations', '$state', 'CssClasses',
  function panelRouterEvaluationCtrl (Validations, $state, CssClasses) {
    const vm = this
    //const currentStage = $state.current.tag
    vm.map = CssClasses.icons.map
    vm.header = {}
    vm.route = ''

    vm.router = router

    vm.$onInit = () => {
      vm.header = setHeader()
      vm.route = setRoute()

      // console.log(vm.header);
      // console.log(vm.route);
    }

    // let inReview = Validations.inReview(currentStage);
    // let inApproval = Validations.inApproval(currentStage);
    // let inEvaluation = Validations.inEvaluation(currentStage);
    // let inReviewExecution = Validations.inReviewExecution(currentStage);

    function setRoute () {
      return 'evaluationTeaching'
    }

    function setHeader () {
      return {
        teacherId: vm.data.teacherId,
        workplanId: vm.data.workplanId,
        name: vm.data.name
      }
    }

    function router (route, header) {
      let updatedHeader = {
        teacherId: vm.data.teacherId,
        workplanId: vm.data.workplanId,
        name: vm.data.name
      }
      $state.go(`workplan.${route}`, updatedHeader)
    }
  }
]}


// WEBPACK FOOTER //
// ./src/app/u-faculty/components/panel-router-evaluation.js